import React from 'react';
import hand from '../assets/hand.png';
import fold from '../assets/fold.png';
import assemble from '../assets/assemble.png';
import paint from '../assets/paint.png';
import weld from '../assets/weld.png';
import glue from '../assets/glue.png';
import blue from '../assets/blue.png';
import wooden from '../assets/wooden.png';
import {CrossIcon, Avatar} from 'evergreen-ui'



export let Icons = {
    folding: [<img src={fold} width={30}/>, <img src={hand}  width={40}/>],
    gluing: [<img src={glue} />, <img src={hand} />],
    welding: [<img src={weld} />, <img src={hand} />],
    assembly: [<img src={assemble} />, <img src={hand} />],
    painting: [<img src={paint} />, <img src={hand} />],
    blue: <img src={blue} style={{width: "20%"}}/>,
    wood: <img src={wooden} style={{width: "100%", cursor: "pointer"}}/>,

    nomaterial: <CrossIcon size={50}/>,

};
